<div
  class="container flex bg-project-800 my-0 mx-auto w-full min-w-[1260px] max-w-[1460px] min-h-[calc(100vh_-_80px)]"
>
  <div class="flex-1 basis-full max-w-[8%]">
    <app-sidebar></app-sidebar>
  </div>
  <div class="h-full max-h-full pr-5 pl-[5px] flex-1 basis-full max-w-[92%]">
    <app-alert></app-alert>
    <router-outlet></router-outlet>
  </div>
</div>
